function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 3.66669L8.075 8.05002C8.34888 8.23275 8.67075 8.33027 9 8.33027C9.32925 8.33027 9.65112 8.23275 9.925 8.05002L16.5 3.66669M3.16667 12.8334H14.8333C15.2754 12.8334 15.6993 12.6578 16.0118 12.3452C16.3244 12.0326 16.5 11.6087 16.5 11.1667V2.83335C16.5 2.39133 16.3244 1.9674 16.0118 1.65484C15.6993 1.34228 15.2754 1.16669 14.8333 1.16669H3.16667C2.72464 1.16669 2.30072 1.34228 1.98816 1.65484C1.67559 1.9674 1.5 2.39133 1.5 2.83335V11.1667C1.5 11.6087 1.67559 12.0326 1.98816 12.3452C2.30072 12.6578 2.72464 12.8334 3.16667 12.8334Z",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgWhiteLetterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLetterIcon);
export default __webpack_public_path__ + "static/media/white-letter-icon.559872c2.svg";
export { ForwardRef as ReactComponent };